import { MNElement } from '../elements/elementModelTypes';
import { ModelUsage } from './aiUsageTypes';
import { ElementType } from '../elements/elementTypes';

export const AI_MESSAGE_SOURCE_ROOT = 'root';

export const isAIConversationMessage = (obj: unknown): obj is AiConversationMessage =>
    typeof obj === 'object' && obj !== null && 'role' in obj && 'content' in obj && 'visibility' in obj;

export type AIConversationMessageRole = 'user' | 'assistant' | 'system';
export interface AiConversationMessage {
    _id?: string;
    role: AIConversationMessageRole;
    content: string;
    source?: string;
    visibility: {
        user: boolean;
        assistant: boolean;
    };
}

export interface AIConversationDebugInfo {
    prompt: { role: AIConversationMessageRole; content: string }[];
    completionContent: string;
}

export interface AiConversation {
    _id: string;
    userId: string;
    messages: AiConversationMessage[];
    title?: string;
    createdAt: Date | string;
    updatedAt: Date | string;
}

export enum ConversationHistoryType {
    IDEAS = 'ideas-structured-text-no-followup',
    FOLLOWUP_PROMPTS = 'followup-prompts',
    TITLE = 'title',
}

// Simple element format to be returned from openai completion ai

export enum AiIdeaType {
    OTHER = 'other',
    IDEA = 'idea',
    COLOR = 'color',
    TASK = 'task',
    FOLLOWUP = 'followup',
}

export type AiIdea = {
    id?: string;
    type: AiIdeaType;

    text: string;

    // optional hex code for color type
    hex?: string;
};

export const isIdeaObject = (obj: unknown): obj is AiIdea =>
    typeof obj === 'object' && obj !== null && 'type' in obj && 'text' in obj;

export type AiConversationProjection = Partial<{ [key in keyof AiConversation]: number }>;

// Types expected by the client

export type AIResponseElement = Partial<MNElement> & {
    uuid: string;
};

export type AiDebugInfo = Partial<{
    uuid: string;
    elementType: ElementType;
    debugInfo: {
        prompt: { role: string; content: string }[];
        completionContent: string;
        usage: ModelUsage;
    };
}>;
